import { Box } from "@mui/material";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";

export const SimilarTranslationItem = ({
  text,
  fileName,
  groupName,
  idInFile,
  originalText,
  onCopyClick,
}: {
  text: string;
  fileName?: string;
  groupName: string;
  idInFile: string;
  originalText: string;
  onCopyClick: (text: string) => void;
}) => (
  <Box sx={{ mb: 1, fontSize: 14, display: "flex" }}>
    <Box sx={{ flex: 1 }}>
      <Box sx={{ fontSize: 12, color: "#838383" }}>Original:</Box>
      <Box>{originalText}</Box>
    </Box>
    <Box sx={{ flex: 1, pl: 2 }}>
      <Box sx={{ fontSize: 12, color: "#838383" }}>
        Translation: {fileName} : {groupName} : {idInFile}
      </Box>
      <Box>{text}</Box>
    </Box>
    <Box sx={{ width: 20, pl: 1, pt: 1 }}>
      {text ? (
        <Box component="span" sx={{ cursor: "pointer", color: "#1976d2" }} onClick={() => onCopyClick(text)}>
          <ClipboardDocumentListIcon width={24} height={24} />
        </Box>
      ) : null}
    </Box>
  </Box>
);
